import React from 'react';
import { $Logo, $Content } from './styles';
import { SvgIcon } from '../SvgIcon';
export const CallLogo = ({ logo, title, upload, onLogoClick = () => null }) => React.createElement($Logo, { src: logo, onClick: onLogoClick }, logo ? '' :
    upload ? React.createElement($Content, null,
        React.createElement(SvgIcon, { name: 'addPhoto', size: 20 }),
        React.createElement("span", null, "Click to upload Image"))
        : title.substring(0, 2).toLocaleUpperCase());
